export default "__VITE_ASSET__BwqFR7wO__"